module.exports = __webpack_public_path__ + "img/Frame4248.19377f48.png";